var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab ec-container" }, [
    _c(
      "div",
      { staticClass: "nav-wrap" },
      _vm._l(_vm.tabList, function (tab, index) {
        return _c(
          "div",
          {
            key: index,
            ref: tab.route.name,
            refInFor: true,
            staticClass: "nav-itemwrap",
          },
          [
            tab.subRoutes
              ? _c(
                  "div",
                  { staticClass: "nav-item" },
                  _vm._l(tab.subRoutes, function (sub, idx) {
                    return _c(
                      "div",
                      {
                        key: idx,
                        ref: sub.name,
                        refInFor: true,
                        staticClass: "nav-content",
                        class: {
                          "router-link-exact-active": _vm.isActiveLink(
                            sub.name
                          ),
                        },
                        style: {
                          width: "calc(100% / " + tab.subRoutes.length + ")",
                        },
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: sub.name } } },
                          [
                            _c(
                              "span",
                              {
                                class: {
                                  "anchor-nav-active":
                                    sub.name === _vm.$route.name,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t(sub.name.toUpperCase())) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "tab-content" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }